<template>
	<div
		class="golden-corner"
		:class="{
			'golden-corner--top-left': top && left,
			'golden-corner--top-right': top && right,
			'golden-corner--bottom-left': bottom && left,
			'golden-corner--bottom-right': bottom && right,
		}"
	>
		<svg
			v-if="top && left"
			class="top-left"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 60 60"
		>
			<defs>
				<linearGradient
					id="linear-gradient-top-left"
					x1="7.76"
					y1="52.24"
					x2="16.24"
					y2="43.76"
					gradientTransform="translate(60) rotate(90)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stop-color="#6b501e" />
					<stop offset=".5" stop-color="#af8332" />
					<stop offset="1" stop-color="#e3bc75" />
				</linearGradient>
			</defs>
			<path
				class="cls-2"
				d="M3,3h49.76l-4.36,4.36c-3.04-.9-6.19-1.36-9.4-1.36-5.58,0-11.09,1.42-15.94,4.11l-2.93,1.62,1.93,2.73c2.61,3.69,4.22,7.91,4.74,12.35-4.44-.52-8.66-2.14-12.35-4.74l-2.73-1.93-1.62,2.93c-2.69,4.84-4.11,10.35-4.11,15.94,0,3.21.46,6.36,1.36,9.4l-4.36,4.36V3ZM18,12c0-3.31-2.69-6-6-6s-6,2.69-6,6,2.69,6,6,6,6-2.69,6-6Z"
			/>
			<path
				class="cls-3"
				d="M18,12c0-3.31-2.69-6-6-6s-6,2.69-6,6,2.69,6,6,6,6-2.69,6-6ZM9,12c0-1.66,1.34-3,3-3s3,1.34,3,3-1.34,3-3,3-3-1.34-3-3Z"
			/>
			<polygon class="cls-1" points="0 60 0 0 3 3 3 52.76 0 60" />
			<polygon
				class="cls-4"
				points="0 60 3 52.76 7.36 48.4 10.79 49.21 0 60"
			/>
			<path
				class="cls-4"
				d="M10.79,49.21l-3.43-.81c-.9-3.04-1.36-6.19-1.36-9.4,0-5.58,1.42-11.09,4.11-15.94l1.62-2.92,1,4.38c-2.38,4.29-3.73,9.23-3.73,14.48,0,3.59.63,7.02,1.79,10.21Z"
			/>
			<path
				class="cls-4"
				d="M30,30c-6.43,0-12.39-2.03-17.27-5.48l-1-4.38,2.73,1.93c3.69,2.61,7.91,4.22,12.35,4.74l3.19,3.19Z"
			/>
			<path
				class="cls-4"
				d="M30,30l-3.19-3.19c-.52-4.44-2.13-8.66-4.74-12.35l-1.93-2.73,4.38,1c3.45,4.88,5.48,10.84,5.48,17.27Z"
			/>
			<path
				class="cls-4"
				d="M24.52,12.73l-4.38-1,2.92-1.62c4.85-2.69,10.36-4.11,15.94-4.11,3.21,0,6.36.46,9.4,1.36l.81,3.43c-3.19-1.16-6.62-1.79-10.21-1.79-5.25,0-10.19,1.35-14.48,3.73Z"
			/>
			<polygon
				class="cls-4"
				points="49.21 10.79 48.4 7.36 52.76 3 60 0 49.21 10.79"
			/>
			<polygon class="cls-1" points="52.76 3 3 3 0 0 60 0 52.76 3" />
		</svg>
		<svg
			v-if="top && right"
			class="top-right"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 60 60"
		>
			<defs>
				<linearGradient
					id="linear-gradient-top-right"
					x1="16.24"
					y1="52.24"
					x2="7.76"
					y2="43.76"
					gradientTransform="translate(60 60) rotate(-180)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stop-color="#6b501e" />
					<stop offset=".5" stop-color="#af8332" />
					<stop offset="1" stop-color="#e3bc75" />
				</linearGradient>
			</defs>
			<path
				class="cls-3"
				d="M57,3v49.76l-4.36-4.36c.9-3.04,1.36-6.19,1.36-9.4,0-5.58-1.42-11.09-4.11-15.94l-1.62-2.93-2.73,1.93c-3.69,2.61-7.91,4.22-12.35,4.74.52-4.44,2.14-8.66,4.74-12.35l1.93-2.73-2.93-1.62c-4.84-2.69-10.35-4.11-15.94-4.11-3.21,0-6.36.46-9.4,1.36L7.24,3h49.76ZM48,18c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6Z"
			/>
			<path
				class="cls-4"
				d="M48,18c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6ZM48,9c1.66,0,3,1.34,3,3s-1.34,3-3,3-3-1.34-3-3,1.34-3,3-3Z"
			/>
			<polygon class="cls-1" points="0 0 60 0 57 3 7.24 3 0 0" />
			<polygon
				class="cls-2"
				points="0 0 7.24 3 11.6 7.36 10.79 10.79 0 0"
			/>
			<path
				class="cls-5"
				d="M10.79,10.79l.81-3.43c3.04-.9,6.19-1.36,9.4-1.36,5.58,0,11.09,1.42,15.94,4.11l2.92,1.62-4.38,1c-4.29-2.38-9.23-3.73-14.48-3.73-3.59,0-7.02.63-10.21,1.79Z"
			/>
			<path
				class="cls-1"
				d="M30,30c0-6.43,2.03-12.39,5.48-17.27l4.38-1-1.93,2.73c-2.61,3.69-4.22,7.91-4.74,12.35l-3.19,3.19Z"
			/>
			<path
				class="cls-5"
				d="M30,30l3.19-3.19c4.44-.52,8.66-2.13,12.35-4.74l2.73-1.93-1,4.38c-4.88,3.45-10.84,5.48-17.27,5.48Z"
			/>
			<path
				class="cls-1"
				d="M47.27,24.52l1-4.38,1.62,2.92c2.69,4.85,4.11,10.36,4.11,15.94,0,3.21-.46,6.36-1.36,9.4l-3.43.81c1.16-3.19,1.79-6.62,1.79-10.21,0-5.25-1.35-10.19-3.73-14.48Z"
			/>
			<polygon
				class="cls-2"
				points="49.21 49.21 52.64 48.4 57 52.76 60 60 49.21 49.21"
			/>
			<polygon class="cls-5" points="57 52.76 57 3 60 0 60 60 57 52.76" />
		</svg>
		<svg
			v-if="bottom && right"
			class="bottom-right"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 60 60"
		>
			<defs>
				<linearGradient
					id="linear-gradient-bottom-right"
					x1="16.24"
					y1="43.76"
					x2="7.76"
					y2="52.24"
					gradientTransform="translate(0 60) rotate(-90)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stop-color="#6b501e" />
					<stop offset=".5" stop-color="#af8332" />
					<stop offset="1" stop-color="#e3bc75" />
				</linearGradient>
			</defs>
			<path
				class="cls-2"
				d="M57,57H7.24l4.36-4.36c3.04.9,6.19,1.36,9.4,1.36,5.58,0,11.09-1.42,15.94-4.11l2.93-1.62-1.93-2.73c-2.61-3.69-4.22-7.91-4.74-12.35,4.44.52,8.66,2.14,12.35,4.74l2.73,1.93,1.62-2.93c2.69-4.84,4.11-10.35,4.11-15.94,0-3.21-.46-6.36-1.36-9.4l4.36-4.36v49.76ZM42,48c0,3.31,2.69,6,6,6s6-2.69,6-6-2.69-6-6-6-6,2.69-6,6Z"
			/>
			<path
				class="cls-3"
				d="M42,48c0,3.31,2.69,6,6,6s6-2.69,6-6-2.69-6-6-6-6,2.69-6,6ZM51,48c0,1.66-1.34,3-3,3s-3-1.34-3-3,1.34-3,3-3,3,1.34,3,3Z"
			/>
			<polygon class="cls-4" points="60 0 60 60 57 57 57 7.24 60 0" />
			<polygon
				class="cls-1"
				points="60 0 57 7.24 52.64 11.6 49.21 10.79 60 0"
			/>
			<path
				class="cls-1"
				d="M49.21,10.79l3.43.81c.9,3.04,1.36,6.19,1.36,9.4,0,5.58-1.42,11.09-4.11,15.94l-1.62,2.92-1-4.38c2.38-4.29,3.73-9.23,3.73-14.48,0-3.59-.63-7.02-1.79-10.21Z"
			/>
			<path
				class="cls-1"
				d="M30,30c6.43,0,12.39,2.03,17.27,5.48l1,4.38-2.73-1.93c-3.69-2.61-7.91-4.22-12.35-4.74l-3.19-3.19Z"
			/>
			<path
				class="cls-1"
				d="M30,30l3.19,3.19c.52,4.44,2.13,8.66,4.74,12.35l1.93,2.73-4.38-1c-3.45-4.88-5.48-10.84-5.48-17.27Z"
			/>
			<path
				class="cls-1"
				d="M35.48,47.27l4.38,1-2.92,1.62c-4.85,2.69-10.36,4.11-15.94,4.11-3.21,0-6.36-.46-9.4-1.36l-.81-3.43c3.19,1.16,6.62,1.79,10.21,1.79,5.25,0,10.19-1.35,14.48-3.73Z"
			/>
			<polygon
				class="cls-1"
				points="10.79 49.21 11.6 52.64 7.24 57 0 60 10.79 49.21"
			/>
			<polygon class="cls-4" points="7.24 57 57 57 60 60 0 60 7.24 57" />
		</svg>
		<svg
			v-if="bottom && left"
			class="bottom-left"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 60 60"
		>
			<defs>
				<linearGradient
					id="linear-gradient-bottom-left"
					x1="7.76"
					y1="43.76"
					x2="16.24"
					y2="52.24"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stop-color="#6b501e" />
					<stop offset=".5" stop-color="#af8332" />
					<stop offset="1" stop-color="#e3bc75" />
				</linearGradient>
			</defs>
			<path
				class="cls-3"
				d="M3,57V7.24l4.36,4.36c-.9,3.04-1.36,6.19-1.36,9.4,0,5.58,1.42,11.09,4.11,15.94l1.62,2.93,2.73-1.93c3.69-2.61,7.91-4.22,12.35-4.74-.52,4.44-2.14,8.66-4.74,12.35l-1.93,2.73,2.93,1.62c4.84,2.69,10.35,4.11,15.94,4.11,3.21,0,6.36-.46,9.4-1.36l4.36,4.36H3ZM12,42c-3.31,0-6,2.69-6,6s2.69,6,6,6,6-2.69,6-6-2.69-6-6-6Z"
			/>
			<path
				class="cls-4"
				d="M12,42c-3.31,0-6,2.69-6,6s2.69,6,6,6,6-2.69,6-6-2.69-6-6-6ZM12,51c-1.66,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3Z"
			/>
			<polygon class="cls-5" points="60 60 0 60 3 57 52.76 57 60 60" />
			<polygon
				class="cls-2"
				points="60 60 52.76 57 48.4 52.64 49.21 49.21 60 60"
			/>
			<path
				class="cls-1"
				d="M49.21,49.21l-.81,3.43c-3.04.9-6.19,1.36-9.4,1.36-5.58,0-11.09-1.42-15.94-4.11l-2.92-1.62,4.38-1c4.29,2.38,9.23,3.73,14.48,3.73,3.59,0,7.02-.63,10.21-1.79Z"
			/>
			<path
				class="cls-5"
				d="M30,30c0,6.43-2.03,12.39-5.48,17.27l-4.38,1,1.93-2.73c2.61-3.69,4.22-7.91,4.74-12.35l3.19-3.19Z"
			/>
			<path
				class="cls-1"
				d="M30,30l-3.19,3.19c-4.44.52-8.66,2.13-12.35,4.74l-2.73,1.93,1-4.38c4.88-3.45,10.84-5.48,17.27-5.48Z"
			/>
			<path
				class="cls-5"
				d="M12.73,35.48l-1,4.38-1.62-2.92c-2.69-4.85-4.11-10.36-4.11-15.94,0-3.21.46-6.36,1.36-9.4l3.43-.81c-1.16,3.19-1.79,6.62-1.79,10.21,0,5.25,1.35,10.19,3.73,14.48Z"
			/>
			<polygon
				class="cls-2"
				points="10.79 10.79 7.36 11.6 3 7.24 0 0 10.79 10.79"
			/>
			<polygon class="cls-1" points="3 7.24 3 57 0 60 0 0 3 7.24" />
		</svg>
	</div>
</template>

<script setup lang="ts">
interface Props {
	top?: boolean;
	left?: boolean;
	bottom?: boolean;
	right?: boolean;
}

const {
	top = false,
	left = false,
	bottom = false,
	right = false,
} = defineProps<Props>();
</script>

<style lang="scss" scoped>
.golden-corner {
	svg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.top-left {
		.cls-1 {
			fill: #e3bc75;
		}
		.cls-2 {
			fill: #d7a13d;
		}
		.cls-3 {
			fill: url(#linear-gradient-top-left);
		}
		.cls-4 {
			fill: #6b501e;
		}
	}

	.top-right {
		.cls-1 {
			fill: #e3bc75;
		}
		.cls-2 {
			fill: #af8332;
		}
		.cls-3 {
			fill: #d7a13d;
		}
		.cls-4 {
			fill: url(#linear-gradient-top-right);
		}
		.cls-5 {
			fill: #6b501e;
		}
	}

	.bottom-right {
		.cls-1 {
			fill: #e3bc75;
		}
		.cls-2 {
			fill: #d7a13d;
		}
		.cls-3 {
			fill: url(#linear-gradient-bottom-right);
		}
		.cls-4 {
			fill: #6b501e;
		}
	}

	.bottom-left {
		.cls-1 {
			fill: #e3bc75;
		}
		.cls-2 {
			fill: #af8332;
		}
		.cls-3 {
			fill: #d7a13d;
		}
		.cls-4 {
			fill: url(#linear-gradient-bottom-left);
		}
		.cls-5 {
			fill: #6b501e;
		}
	}
}
</style>
